import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import LeadForm from '../components/LeadForm';
import {
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  COMPANY_NAME,
  SALES_EMAIL,
  SUPPORT_EMAIL,
  SUPPORT_PHONE_LABEL,
  SUPPORT_PHONE_TEL,
} from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function ContactPage() {
  return (
    <main>
      <section className="policy__hero">
        <div className="shell">
          <p className="policy__crumbs">
            <Link to="/">Home</Link>
            <span aria-hidden="true"> / </span>
            <span>Contact</span>
          </p>
          <h1>Contact us</h1>
          <p className="policy__updated">
            Call, live chat or send a message — support is available 24/7
          </p>
        </div>
      </section>

      <section className="section">
        <div className="shell consult">
          <div className="consult__copy">
            <h3>Reach the team</h3>
            <ul className="contact-list">
              <li>
                <Icon name="phone" size={20} />
                <div>
                  <small>Call us 24/7</small>
                  <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_LABEL}</a>
                </div>
              </li>
              <li>
                <Icon name="chat" size={20} />
                <div>
                  <small>Live chat</small>
                  <button type="button" className="link-btn" onClick={openZohoChat}>
                    Start a chat now
                  </button>
                </div>
              </li>
              <li>
                <Icon name="mail" size={20} />
                <div>
                  <small>Technical support</small>
                  <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                </div>
              </li>
              <li>
                <Icon name="cart" size={20} />
                <div>
                  <small>Licence sales</small>
                  <a href={`mailto:${SALES_EMAIL}`}>{SALES_EMAIL}</a>
                </div>
              </li>
              <li>
                <Icon name="pin" size={20} />
                <div>
                  <small>{COMPANY_NAME}</small>
                  <span>
                    {ADDRESS_LINE1}, {ADDRESS_LINE2}
                  </span>
                </div>
              </li>
            </ul>

            <div className="consult__cta-row">
              <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
                <Icon name="phone" size={18} />
                Call now
              </a>
              <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
                <Icon name="chat" size={18} />
                Live Chat
              </button>
            </div>

            <p className="contact-note">
              Include your accounting software version and the exact error text if you have it. That
              alone is usually enough for us to give you a first answer without a back and
              forth.
            </p>
          </div>

          <div className="consult__form">
            <LeadForm
              variant="full"
              title="Send us a message"
              subtitle="We reply the same working day — or call us for faster help."
              cta="Send message"
              formName="contact"
            />
          </div>
        </div>
      </section>
    </main>
  );
}
